import React from 'react';
import Pagination from '@mui/material/Pagination';

const CustomPagination=({pageValue , setPage , count})=>{
  
    const handleChange=(event , value)=>{
      setPage(value)
    }
   return(
       <div style={{padding:'15px 0px'}}>
           <Pagination count={count && count.max} page={pageValue} onChange={handleChange}/>
       </div>
   )
}
export default CustomPagination